/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientAttribute from './patient-attribute';
import PatientAttributeDetail from './patient-attribute-detail';
import PatientAttributeUpdate from './patient-attribute-update';
import PatientAttributeDeleteDialog from './patient-attribute-delete-dialog';

const PatientAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientAttribute />} />
    <Route path="new" element={<PatientAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<PatientAttributeDetail />} />
      <Route path="edit" element={<PatientAttributeUpdate />} />
      <Route path="delete" element={<PatientAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientAttributeRoutes;
